import LoyaltyProgressionSFC from "./LoyaltyProgression.vue";
export const LoyaltyProgression = LoyaltyProgressionSFC;
